import styled from "@emotion/styled";
import { Stack } from "@mui/material";
import { LoadingScreen } from "components/LoadingScreen";
import { Notification } from "components/UI";
import { MutationError } from "components/UI/MutationError";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Onboarding } from "../components/Onboarding";
import { useFinanceOnboardingStatus } from "../hooks";

const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  min-height: calc(100vh - 80px);
  background-color: #ffffff;
  align-items: center;
  justify-content: center;
`;

export const FinanceOnboarding = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoading, isError, isOnboardingComplete } =
    useFinanceOnboardingStatus();

  useEffect(() => {
    if (isLoading || isError) return;

    if (isOnboardingComplete && location.pathname !== "/finances/onboarding") {
      navigate("/finances/temp/overview");
    }
  }, [isLoading, isError, navigate, location.pathname, isOnboardingComplete]);

  const steps = {
    budgetYears: true,
    chartOfAccounts: true,
    banks: true,
    approvers: true
  };

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (isError) {
    return (
      <Stack height="100vh" justifyContent="center" alignItems="center">
        <MutationError
          error={{
            errors: "Error loading finance. Please try again."
          }}
        />
      </Stack>
    );
  }

  return (
    <Container>
      <Notification />
      <Onboarding steps={steps} />
    </Container>
  );
};
